import React from "react";
import * as S from "./index.styles";
import { ZipInputFieldProps } from "./LocationFields.types";

const ZipInputField: React.FC<ZipInputFieldProps> = ({
  value, onChange, label, required, border
}) => (
  <S.FieldContainer>
    <S.FieldTitle>
      {label}
      {required && <S.RequiredAsterisk> *</S.RequiredAsterisk>}
    </S.FieldTitle>
    <S.LocationInput
      type="text"
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      placeholder={`Enter ${label}`}
    />
  </S.FieldContainer>
);

export default ZipInputField; 